module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-right.c67f1d5e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Tabs/images/tab-right.png
// module id = 3242
// module chunks = 11